import { Component, Prop, h } from '@stencil/core';

import { VehicleConfig } from '../../../interfaces/interface.vehicle';

@Component({
  tag: 'ico-config-header',
  styleUrl: 'config-header.css',
})
export class ConfigHeader {
  @Prop() vehicleConfig: VehicleConfig = {
    vin: '',
    fullVehicleName: '',
    featuredEngine: '',
    featuredDrivetrain: '',
    featuredTransmission: '',
    featuredColor: '',
    featuredColorHex: '',
    featuredOptions: [],
  } as VehicleConfig;

  shouldShowIcons() {
    const { featuredEngine, featuredDrivetrain, featuredTransmission, featuredColor } = this.vehicleConfig;
    return featuredEngine.length > 0 || featuredDrivetrain.length > 0 || featuredTransmission.length > 0 || featuredColor.length > 0;
  }

  shouldShowModalLink() {
    const { featuredOptions } = this.vehicleConfig;
    return featuredOptions.length > 0;
  }

  renderIcon(icon, label, text) {
    return (
      <div class="text-center w-32 flex flex-col">
        <svg-icon icon={icon} width="3rem" />
        <span class="text-xs">{label}:</span>
        <span class="text-sm font-semibold">{text}</span>
      </div>
    );
  }

  renderColorIcon() {
    // tailwind doesn't like mixing stencil props into tailwind custom classes
    // so style is a workaround
    const { featuredColor, featuredColorHex } = this.vehicleConfig;
    const bgStyle = {
      background: featuredColorHex,
    };
    return (
      <div class="text-center px-6 py-3 w-32 flex flex-col items-center">
        <div class="w-14 h-10 border-solid border border-clrs-kbb-stonegrey mb-3" style={bgStyle}></div>
        <div class="text-xs">Color:</div>
        <div class="text-sm font-semibold">{featuredColor}</div>
      </div>
    );
  }

  render() {
    const { vin, fullVehicleName, featuredEngine, featuredDrivetrain, featuredTransmission, featuredColor, featuredColorHex, featuredOptions } = this.vehicleConfig;
    return (
      <box-shadow class="text-center">
        <div class="ico-components-heading-large mb-3">We Found Your Vehicle!</div>
        <div class="text-sm mb-3">Please help us by answering a few more questions about your car.</div>
        <div class="md:text-2xl font-bold mb-3 text-ico-heading">{fullVehicleName}</div>
        {vin.length > 0 && (
          <div class="mb-3">
            VIN: <span class="font-bold text-ico-heading">{vin}</span>
          </div>
        )}

        {this.shouldShowIcons() && (
          <div class="flex flex-wrap justify-center items-start gap-4 mt-5">
            {featuredEngine && this.renderIcon('config-engine', 'Engine', featuredEngine)}
            {featuredTransmission && this.renderIcon('config-transmission', 'Transmission', featuredTransmission)}
            {featuredDrivetrain && this.renderIcon(`config-drivetrain-${featuredDrivetrain.toLocaleLowerCase()}`, 'Drivetrain', featuredDrivetrain)}
            {featuredColor && featuredColorHex && this.renderColorIcon()}
          </div>
        )}
        {this.shouldShowModalLink() && <vehicle-features-equipment-modal options={featuredOptions}></vehicle-features-equipment-modal>}
      </box-shadow>
    );
  }
}
